import { render, staticRenderFns } from "./CategoryImage.vue?vue&type=template&id=3f7ad099&scoped=true&lang=pug&"
import script from "./CategoryImage.vue?vue&type=script&lang=js&"
export * from "./CategoryImage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryImage.vue?vue&type=style&index=0&id=3f7ad099&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7ad099",
  null
  
)

export default component.exports